import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import CropItem from '@/modules/periodicJobs/components/CropsDropdown/CropItem';
import CropsList from '@/modules/periodicJobs/components/CropsDropdown/CropsList';
import { ICropDropdownProps } from '@/modules/periodicJobs/components/CropsDropdown/ICropsDropdown';
import { PeriodicJobsContext } from '@/modules/periodicJobs/context/context';
import { periodicJobsActionsTypes as ActionsTypes } from '@/modules/periodicJobs/context/reducer';
import { Typography } from '@/shared/components/atoms';

const CropsDropdown: React.FC<ICropDropdownProps> = ({ onClose, crops }) => {
  const { t, i18n } = useTranslation('common');

  const {
    state: { selectedCrop },
    dispatch,
  } = useContext(PeriodicJobsContext);

  const isAr = i18n.language === 'ar';

  const classNames = clsx(
    isAr ? 'right-16' : 'left-16',
    'h-290 w-343',
    'flex flex-col',
    'absolute top-56 z-50',
    ' bg-primary-99 p-16',
    'rounded-xl border-xs border-primary-600'
  );

  return (
    <div className={classNames}>
      <Typography weight='bold' className='mb-12 text-start text-base'>
        {t('crops')}
      </Typography>
      <CropsList>
        {crops?.map((crop) => (
          <CropItem
            key={crop.id}
            imageUrl={crop.image}
            name={crop.name ?? 'Not Found'}
            selected={crop.id === selectedCrop?.id}
            onClick={() => {
              dispatch({ type: ActionsTypes.setCrop, payload: crop });
              dispatch({ type: ActionsTypes.setPlots, payload: [] });
              onClose();
            }}
          />
        ))}
      </CropsList>
    </div>
  );
};

export default CropsDropdown;
